import OptionWrap from "pages/landing/overlayauth/optionWrap";

const ManagePlans=()=>{

    return(<>
    
    <OptionWrap handleVerified={''} />
    </>)
}
export default ManagePlans;